<script lang="ts">
    import { onDestroy } from "svelte";
    import Loading from "../Icons/Loading.svelte";
    import {
        getItemsListManager,
        getItemsListManagerState,
    } from "./ItemsListManager";

    export let onInput: (e: Event) => void;
    export let onKeydown: (e: KeyboardEvent) => void | undefined = undefined;
    export let autoFocus: boolean = false;
    export let classNames: string | undefined = undefined;
    export let ariaLabel: string | undefined = undefined;
    export let placeholder: string | undefined = undefined;

    let state = getItemsListManagerState();
    let manager = getItemsListManager();
    let inputElement: HTMLElement;

    $: {
        manager.addNavigationEventListeners(inputElement);
    }

    onDestroy(() => {
        manager.removeNavigationEventListeners(inputElement);
    });
    let focusCalled = false;
    $: {
        if (autoFocus && inputElement && !focusCalled) {
            focusCalled = true;
            setTimeout(() => {
                inputElement.focus();
            });
        }
    }
</script>

<!-- on:input={onInput} -->
<div class="relative">
    <input
        type="name"
        name="q"
        class="relative {classNames}"
        spellcheck={false}
        autocorrect="off"
        autocomplete="off"
        autocapitalize="none"
        on:keydown={onKeydown}
        on:input={onInput}
        aria-label={ariaLabel}
        bind:this={inputElement}
        {placeholder}
    />
    {#if $state.inProgress}
        <div class="absolute right-0 top-0 p-1">
            <Loading class="w-4 h-4" />
        </div>
    {/if}
</div>
